@for (f of [form()]; track f) {
    <hb-felt-radio aria-live="assertive"
                   [control]="form().controls.control"
                   [alternativer]="alternatives()"
                   [legendText]="legendText"
    >
        {{ legendText }}
    </hb-felt-radio>
}

